module.exports = __webpack_public_path__ + "static/opener-text-a6662c27a400f901751ed1ad6529348d.png";